import { StyledFileGroupContainer, StyledTitleText } from './History.style';
import noDownloadImg from '/assets/image/no_download.svg';
import { StateCard, DownloadCard } from '~/components/Global/Card';
import type { DownloadCardAction } from '~/components/Global/Card/DownloadCard';
import { useSelector } from 'react-redux';
import { getterHistory } from '~/store/resource/resourceGetter';
import { useMemo } from 'react';
import { FileStatus, THistoryItem } from '~/store/resource/resource.type';
import { sendChannel } from '~/utils/constants';
import { downloadHistoryEvent } from '~/tracking';

const ACTION_TO_EVENT_TYPE: Record<DownloadCardAction, string> = {
  [sendChannel.pause]: '暫停',
  [sendChannel.resume]: '繼續',
  [sendChannel.cancel]: '取消',
  [sendChannel.openPath]: '開啟位置',
  [sendChannel.deleteFile]: '刪除',
};

const ListGroup = ({
  list,
  title,
}: {
  list: THistoryItem[];
  title: string;
}) => {
  if (list.length === 0) {
    return null;
  }

  return (
    <StyledFileGroupContainer>
      <StyledTitleText>
        {title}（{list.length}）
      </StyledTitleText>
      {list.map(item => (
        <DownloadCard
          key={item.url}
          history={item}
          onAction={action => {
            downloadHistoryEvent({
              event_type: ACTION_TO_EVENT_TYPE[action],
              resources_url: item.url,
              resources_name: item.fileName,
            });
          }}
        />
      ))}
    </StyledFileGroupContainer>
  );
};

export const History = () => {
  const history = useSelector(getterHistory);

  const hasNoHistory = useMemo(() => {
    return (
      Object.values(history)
        .map(item => item.length)
        .reduce((acc, cur) => acc + cur, 0) === 0
    );
  }, [history]);

  return (
    <>
      {hasNoHistory && (
        <StateCard
          imgSrc={noDownloadImg}
          title="目前尚無任何下載紀錄"
          content="請前往「南一資源」下載想要的資源吧！"
        />
      )}
      <ListGroup list={history[FileStatus.installing]} title="安裝中" />
      <ListGroup list={history[FileStatus.progressing]} title="下載中" />
      <ListGroup list={history[FileStatus.finish]} title="下載完成" />
    </>
  );
};
